var __jsx = React.createElement;
import React, { useState } from "react";
import { faCheck, faXmark } from "@fortawesome/pro-regular-svg-icons";
import AwesomeIcon from "../../AwesomeIcon";
import { isValidPattern, hasInvalidTextCharacters } from "../../../utils/fieldValidation";
var CustomValueInput = function CustomValueInput(_ref) {
  var onChange = _ref.onChange,
    onClose = _ref.onClose,
    pattern = _ref.pattern,
    formatHint = _ref.formatHint,
    maxLength = _ref.maxLength;
  var _useState = useState(""),
    customValue = _useState[0],
    setCustomValue = _useState[1];
  var _useState2 = useState(null),
    error = _useState2[0],
    setError = _useState2[1];
  var handleConfirm = function handleConfirm() {
    var trimmedValue = customValue.trim();
    if (!trimmedValue) {
      return;
    }

    // Validate pattern if provided
    if (pattern) {
      if (hasInvalidTextCharacters(trimmedValue, pattern)) {
        setError(formatHint ? "Format: ".concat(formatHint) : "Invalid format");
        return;
      }
      if (!isValidPattern(trimmedValue, pattern)) {
        setError(formatHint ? "Format: ".concat(formatHint) : "Invalid format");
        return;
      }
    }

    // If validation passes, apply the value
    setError(null);
    onChange(trimmedValue);
    onClose();
    setCustomValue("");
  };
  var handleChange = function handleChange(e) {
    setCustomValue(e.target.value);
    setError(null);
  };
  var handleClear = function handleClear(e) {
    e.preventDefault();
    e.stopPropagation();
    setCustomValue("");
    setError(null);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "px-4 py-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-start gap-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-left flex items-center",
    style: {
      width: "30%",
      height: "36px"
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-[14px] text-gray-900 dark:text-white"
  }, "Other -")), /*#__PURE__*/React.createElement("div", {
    className: "relative",
    style: {
      width: "70%"
    }
  }, /*#__PURE__*/React.createElement("input", {
    type: "text",
    value: customValue,
    onChange: handleChange,
    onKeyDown: function onKeyDown(e) {
      if (e.key === "Enter") {
        handleConfirm();
      }
    },
    placeholder: formatHint || "Enter custom value...",
    maxLength: maxLength !== null && maxLength !== void 0 ? maxLength : undefined,
    className: "w-full px-3 py-2 border rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:outline-none focus:border-2 focus:!border-teal-500 dark:focus:!border-teal-400 text-[14px] ".concat(customValue ? "pr-[72px]" : "pr-[40px]", " ").concat(error ? "border-red-500 focus:border-red-400" : "border-gray-300 dark:border-gray-600 focus:border-gray-500 dark:focus:border-gray-400"),
    style: {
      height: "36px"
    }
  }), error && /*#__PURE__*/React.createElement("div", {
    className: "mt-1 ml-2 text-left text-red-600 dark:text-red-400 text-sm"
  }, error), /*#__PURE__*/React.createElement("div", {
    className: "absolute top-1 right-1 flex items-center gap-1"
  }, customValue && /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: handleClear,
    className: "flex items-center justify-center text-gray-500 dark:text-gray-400 hover:text-gray-600 dark:hover:text-gray-400 focus:outline-none",
    style: {
      width: "32px",
      height: "32px"
    },
    title: "Clear"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faXmark,
    className: "h-4 w-4"
  })), /*#__PURE__*/React.createElement("button", {
    onClick: handleConfirm,
    disabled: !customValue.trim(),
    className: "flex items-center self-center justify-center bg-teal-600 hover:bg-teal-700 text-white rounded-6 disabled:opacity-50 disabled:cursor-not-allowed transition-colors",
    style: {
      width: "32px",
      height: "32px"
    },
    title: "Confirm"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faCheck,
    className: "h-4 w-4"
  }))))));
};
export default CustomValueInput;